export default "__VITE_ASSET__CKUAwiKv__"